import React from "react";
import AppRouter from "./routes/AppRouter";
// import "./hooks/i18n";

function App() {
    return (<AppRouter />);
}

export default App;